import { Injectable, signal } from '@angular/core';
import { Notice } from '@xanadu/model';

@Injectable({
    providedIn: 'root'
})
export class NoticeSignal {
    notice = signal<Notice | undefined>(undefined);

    info(text: string) {
        const notice = Notice.info(text);
        this.notice.set(notice);
    }

    warning(text: string) {
        const notice = Notice.warning(text);
        this.notice.set(notice);
    }

    error(text: string) {
        const notice = Notice.error(text);
        this.notice.set(notice);
    }
}
